(function($){
    $(document).ready(function(){
        $(".header__nav .menu-item-has-children").hoverIntent({
            interval: 10, // milliseconds delay before onMouseOver
            over: function() {
                $(this).addClass('js-hover');
                $(this).find('.sub-menu-wrapper [data-mh]').matchHeight();
                var fade = { opacity: 1, transition: 'opacity 0.5s' };
                $(this).find('.sub-menu-wrapper').stop().hide(0).css(fade).slideDown(200);
            },
            timeout: 300, // milliseconds delay before onMouseOut
            out: function() {
                var $this = $(this);
                var fade = { opacity: 0, transition: 'opacity 0.5s' };
                $(this).find('.sub-menu-wrapper').stop().css(fade).slideUp(200, function() {
                    $this.removeClass('js-hover');
                });
            },
        });
        $(".header__nav .menu-item-has-children").on('hover', function() {
            $(this).closest('.header__nav').find('.js-hover').not(this).find('.sub-menu-wrapper').stop().slideUp(200, function() {
                $(this).closest('.js-hover').removeClass('js-hover');
            });
        });

        $('#goTop').goTop({
            src: "icon icon-chevron-up",
            marginY: 10
        });
    });
})(jQuery);